<template>
<div v-if="!isPageLoading">
    <div v-if="hasAdminAccess && (user != null || currentuser != null)">
        <v-card>
            <v-card-title v-show="!isLoggedInUserActive">
                <label style="color: red">{{ $t("msguserisnotactive") }}</label>
            </v-card-title>
        </v-card>
        <v-tabs v-model="tab" fixed-tabs background-color="#6b6b6b" dark>
            <v-tabs-slider color="#1976d2"></v-tabs-slider>
            <v-tab v-for="cmitem in categoryMasters" :key="cmitem.categoryId" @change="tabChanged(cmitem.categoryId)">
                <span v-if="cmitem.categoryName == 'Maintainence Group'">
                    {{ $t("maintgrps") }}
                </span>
                <span v-if="cmitem.categoryName == 'User Companies'">
                    {{ $t("companies") }}
                </span>
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item v-for="cmitem in categoryMasters" :key="cmitem.categoryId">
                <v-card>
                    <v-data-table :headers="headers(cmitem.categoryName)" :items="filteredCategoryData" :search="search" v-show="isLoggedInUserActive" :footer-props="{
                itemsPerPageOptions: tableItemsPerPage,
                itemsPerPageText: rowsperpage,
              }" :options="options">
                        <template v-slot:top>
                            <v-dialog v-model="dialogDelete" max-width="500px">
                                <v-card light flat>
                                    <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-progress-circular indeterminate color="primary" v-show="deleteinProgress"></v-progress-circular>
                                        <v-btn color="blue darken-1" text @click="closeDelete" v-show="!deleteinProgress">Close</v-btn>
                                        <v-btn color="blue darken-1" text @click="deleteItemConfirm" v-show="!deleteinProgress">OK</v-btn>
                                        <v-spacer></v-spacer>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                            <v-toolbar flat dense>
                                <v-dialog v-model="dialog" max-width="500px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">{{ $t("new") }}</v-btn>
                                    </template>
                                    <!-- Display status / error messages coming from api -->
                                    <div id="error" v-show="dialog && statusmessages.length > 0">
                                        <v-alert :value="true" type="error">
                                            <div>
                                                <ul>
                                                    <li v-for="(status, index) in statusmessages" :key="index">
                                                        {{ status.message }}
                                                    </li>
                                                </ul>
                                            </div>
                                        </v-alert>
                                    </div>
                                    <v-card>
                                        <v-card-title>
                                            <span class="headline">{{ formTitle }}</span>
                                            <v-spacer></v-spacer>
                                            <v-icon @click="close(1)">close</v-icon>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-container>
                                                <v-row>
                                                    <v-col cols="12" sm="8" md="8" v-show="false">
                                                        <v-select :items="categoryMasters" v-bind:label="$t('category')" v-model="selectedTab" item-text="categoryName" item-value="categoryId" disabled>
                                                        </v-select>
                                                    </v-col>
                                                    <v-col cols="12" sm="8" md="8">
                                                        <v-select style="background-color: #ffffcc" :items="plants" v-bind:label="$t('plant') + ' *'" v-model="selecttedplant" item-text="plant" item-value="id" @change="changePlant">
                                                        </v-select>
                                                    </v-col>
                                                    <v-col cols="12" sm="8" md="8">
                                                        <v-text-field v-model="editedItem.value" v-bind:label="
                                  (selectedTab == 1
                                    ? $t('company')
                                    : selectedTab == 2
                                    ? $t('maintgrp')
                                    : selectedTab == 3
                                    ? $t('businessunit')
                                    : $t('discipline')) + ' *'
                                "></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" sm="6" md="6">
                                                        <v-text-field v-model="editedItem.otherInfo" v-bind:label="$t('otherinfo')"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-btn color="blue darken-1" text @click="close(1)">{{
                          $t("cancel")
                        }}</v-btn>
                                            <v-spacer></v-spacer>
                                            <v-btn color="primary" dark class="mb-2" @click="save">{{ $t("save") }}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-text-field v-model="search" append-icon="mdi-magnify" v-bind:label="$t('searchall')" single-line hide-details></v-text-field>
                            </v-toolbar>
                        </template>
                        <template v-slot:[`item.action`]="{ item }">
                            <v-icon small class="mr-2" @click="editItem(item)">
                                mdi-pencil
                            </v-icon>
                            <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
                        </template>
                        <template v-slot:no-data>
                            <v-alert border="right" colored-border type="error" elevation="2">
                                {{ $t("norecordsfound") }}
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </div>
    <div v-else-if="user != null || currentuser != null">
        <v-alert outlined type="warning" prominent border="left">
            {{ $t("accessdenied") }}
        </v-alert>
    </div>
</div>
<div v-else>
    <v-progress-linear indeterminate color="teal" rounded height="8"></v-progress-linear>
</div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import i18n from "@/plugins/i18n";
import requestsMixin from "@/mixins/requests"
export default {
    mixins: [requestsMixin],
    data() {
        return {
            search: "",
            categoryMasters: [],
            allCategoryData: [],
            platCategoryData: [],
            filteredCategoryData: [],
            tab: null,
            selectedTab: null,
            allplants: [],
            plants: [],
            dialog: false,
            statusmessages: [],
            isSucess: false,
            editedIndex: -1,
            fEditedIndex: -1,
            selecttedplant: 0,
            selectedcontractor: 0,
            selectedmaintgrp: 0,
            editedItem: {
                id: 0,
                categoryId: 0,
                plant: 0,
                value: "",
                otherInfo: "",
                updatedBy: "",
                updatedOn: new Date().toISOString(),
            },
            defaultItem: {
                id: 0,
                categoryId: 0,
                plant: -1,
                value: "",
                otherInfo: "",
                updatedBy: "",
                updatedOn: new Date().toISOString(),
            },
            date: new Date().toISOString().substr(0, 10),
            dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
            searchUser: null,
            entries: [],
            useraccess: [],
            currentuser: [],
            isPageLoading: true,
            user: null,
            tableItemsPerPage: [25, 50, 100, -1],
            options: null,
            deleteinProgress: false,
            dialogDelete: false,
        };
    },
    mounted() {
        this.getCategoryMasterFromAPI();
    },
    methods: {
        getCategoryMasterFromAPI() {
            var self = this;
            self.isPageLoading = true;
            self.user = self.$store.state.userDetails;
            const link = window.apiurl + "/MppiChCategoryMasters";
            axios
                .get(link, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.categoryMasters = response.data;
                    if (self.user != null) {
                        const link2 =
                            window.apiurl + "/userheadcount/myview/" + self.user.userEmail;
                        axios
                            .get(link2, {
                                withCredentials: true,
                                headers: self.requestHeaders
                            })
                            .then((response) => {
                                self.useraccess = response.data;
                                i18n.locale = self.useraccess[0].language;
                                if (self.useraccess[0].rowsPerPage != null) {
                                    var rowsPrPg =
                                        self.useraccess[0].rowsPerPage == "All" ?
                                        -1 :
                                        parseInt(self.useraccess[0].rowsPerPage);
                                    self.options = {
                                        itemsPerPage: rowsPrPg,
                                    };
                                } else {
                                    self.options = {
                                        itemsPerPage: 25,
                                    };
                                }
                                self.isPageLoading = false;
                            })
                            .then((response1) => {
                                self.getPlants();
                            })
                            .catch((error) => console.log(error));
                    } else {
                        self.getUser();
                    }
                })
                .catch((error) => console.log(error));
        },
        getCategoryDataFromAPI() {
            var self = this;
            const link = window.apiurl + "/MppiChCategoriesDatas";
            axios
                .get(link, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.allCategoryData = response.data;
                    if (self.plants.length > 0) {
                        self.plants.forEach(function (elem, index) {
                            Array.prototype.push.apply(
                                self.platCategoryData,
                                self.allCategoryData.filter(function (e) {
                                    return e.plant == elem.plant;
                                })
                            );
                        });
                    }
                    self.tabChanged(1);
                })
                .catch((error) => console.log(error));
        },
        tabChanged(tabid) {
            var self = this;
            self.selectedTab = tabid;
            self.filteredCategoryData = self.platCategoryData.filter(function (e) {
                return e.categoryId == tabid;
            });
        },
        getPlants() {
            var self = this;
            const link3 = window.apiurl + "/plants";
            axios
                .get(link3, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.allplants = response.data;
                    var filterUser = [];
                    filterUser = self.useraccess.filter(
                        (x) => x.plant == "Global" && x.isActive == "Y"
                    );
                    if (filterUser != null && filterUser.length > 0) {
                        self.plants = self.allplants.slice();
                    } else {
                        var filterPlant = [];
                        filterPlant = self.useraccess.filter(
                            (x) => x.company == "LYB" && x.isActive == "Y"
                        );
                        if (filterPlant != null && filterPlant.length > 0) {
                            var index = 0;
                            for (index = 0; filterPlant.length > index; index++) {
                                var plant = self.allplants.filter(
                                    (x) => x.plant == filterPlant[index].plant
                                );
                                self.plants.push(plant[0]);
                            }
                        }
                    }
                    self.getCategoryDataFromAPI();
                })
                .catch((error) => console.log(error));
        },
        getUser() {
            var self = this;
            axios
                .get(window.apiurl + "/usercontext", {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.currentuser = response.data;
                    const link4 =
                        window.apiurl +
                        "/userheadcount/myview/" +
                        self.currentuser.userEmail;
                    axios
                        .get(link4, {
                            withCredentials: true,
                            headers: self.requestHeaders
                        })
                        .then((response1) => {
                            self.useraccess = response1.data;
                            self.isPageLoading = false;
                        })
                        .then(() => self.getPlants())
                        .catch((error) => console.log(error));
                })
                .then(() => self.$store.commit("globalUser", self.currentuser))
                .catch((error) => console.log(error));
        },
        close(isCancel) {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                this.fEditedIndex = -1;
                this.selecttedplant = 0;
            });
            if (isCancel == 1) {
                this.$toast.clear();
            }
        },
        editItem(item) {
            this.editedIndex = this.allCategoryData.indexOf(item);
            this.fEditedIndex = this.filteredCategoryData.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.selecttedplant = this.plants.find(
                (x) => x.plant == this.editedItem.plant
            ).id;
            this.dialog = true;
        },
        deleteItem(item) {
            this.editedIndex = this.allCategoryData.indexOf(item);
            this.fEditedIndex = this.filteredCategoryData.indexOf(item);
            this.editedItem.id = item.id
            this.dialogDelete = true;
            this.deleteinProgress = false;
        },
        deleteItemConfirm() {
            this.deleteinProgress = true;
            var self = this;
            const link = window.apiurl + "/MppiChCategoriesDatas/delete/" + this.editedItem.id;
            axios
                .delete(link, { withCredentials: true, headers: self.requestHeaders })
                .then(function (response) {
                    debugger
                    if (response.data.isSucess) {
                        self.allCategoryData.splice(self.editedIndex, 1);
                        self.filteredCategoryData.splice(self.fEditedIndex, 1);
                        //alert(response.data.messages[0].message);
                        self.$toast.clear();
                        self.$toast.success(self.$t("msgrecorddeleted"));
                    } else {
                        var index1 = 0;
                        for (
                            index1 = 0; index1 < response.data.messages.length; index1++
                        ) {
                            self.statusmessages.push(response.data.messages[index1]);
                        }
                        self.$toast.clear();
                        self.$toast.error(self.statusmessages[0]);
                    }
                    self.closeDelete()
                })
                .catch(function (err) {
                    console.log(err);
                });
        },
        closeDelete() {
            this.dialogDelete = false;
        },
        save() {
            var self = this;
            if (self.selecttedplant == 0 || self.editedItem.value == "") {
                self.$toast.clear();
                self.$toast.error(this.$t("errfillrequiredfields"), {
                    timeout: false,
                });
            } else {
                this.editedItem.categoryId = this.selectedTab;
                this.editedItem.plant = this.plants.find(
                    (x) => x.id == this.selecttedplant
                ).plant;
                this.editedItem.updatedBy = this.user.userEmail;
                var object = null;

                if (self.editedIndex > -1) {
                    const link = window.apiurl + "/MppiChCategoriesDatas/update";
                    axios
                        .put(link, this.editedItem, {
                            withCredentials: true,
                            headers: self.requestHeaders
                        })
                        .then((response) => {
                            if (response.data.isSucess) {
                                //alert(response.data.messages[0].message);
                                self.$toast.clear();
                                self.$toast.success(
                                    self.getTabName + self.$t("msgcategorydataedited")
                                );
                                Object.assign(
                                    self.allCategoryData[self.editedIndex],
                                    self.editedItem
                                );
                                Object.assign(
                                    self.filteredCategoryData[self.fEditedIndex],
                                    self.editedItem
                                );
                                self.close();
                            } else {
                                var index = 0;
                                for (
                                    index = 0; index < response.data.messages.length; index++
                                ) {
                                    self.statusmessages.push(response.data.messages[index]);
                                }
                            }
                            self.close();
                        })
                        .catch((error) => console.log(error));
                } else {
                    if (
                        this.allCategoryData.find(
                            (x) =>
                            x.plant == this.editedItem.plant &&
                            x.value == this.editedItem.value &&
                            x.categoryId == this.editedItem.categoryId
                        ) != null
                    )
                        object = this.allCategoryData.find(
                            (x) =>
                            x.plant == this.editedItem.plant &&
                            x.value == this.editedItem.value &&
                            x.categoryId == this.editedItem.categoryId
                        );
                    if (object == null) {
                        const link = window.apiurl + "/MppiChCategoriesDatas/create";
                        axios
                            .post(link, this.editedItem, {
                                withCredentials: true,
                                headers: this.requestHeaders
                            })
                            .then(function (response) {
                                if (response.data.isSucess) {
                                    const newMSItem = {
                                        id: 0,
                                        plant: "",
                                        value: "",
                                        otherInfo: "",
                                        updatedBy: "",
                                        updatedOn: new Date(),
                                        categoryId: 0,
                                    };
                                    newMSItem.id = response.data.categoriesMasterData.id;
                                    newMSItem.plant = response.data.categoriesMasterData.plant;
                                    newMSItem.value = response.data.categoriesMasterData.value;
                                    newMSItem.otherInfo =
                                        response.data.categoriesMasterData.otherInfo;
                                    newMSItem.updatedBy =
                                        response.data.categoriesMasterData.updatedBy;
                                    newMSItem.updatedOn =
                                        response.data.categoriesMasterData.updatedOn;
                                    newMSItem.categoryId =
                                        response.data.categoriesMasterData.categoryId;
                                    self.allCategoryData.push(newMSItem);
                                    self.filteredCategoryData.push(newMSItem);
                                    self.$toast.clear();
                                    self.$toast.success(
                                        self.getTabName + self.$t("msgcategorydataedited")
                                    );
                                    //alert(response.data.messages[0].message);
                                    self.close();
                                } else {
                                    var index = 0;
                                    for (
                                        index = 0; index < response.data.messages.length; index++
                                    ) {
                                        self.statusmessages.push(response.data.messages[index]);
                                    }
                                }
                            })
                            .catch(function (err) {
                                console.log(err);
                            });
                        this.close();
                    } else {
                        //alert("Item already exists with plant");
                        self.$toast.clear();
                        self.$toast.error(self.getTabName + this.$t("errtabexists"), {
                            timeout: false,
                        });
                    }
                }
            }
        },
        changePlant(selecetedObj) {
            // if (selecetedObj === parseInt(selecetedObj)) {
            // }
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${month}/${day}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;

            const [month, day, year] = date.split("/");
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        },
        headers(categoryName) {
            return [{
                    text: this.$t("plant"),
                    align: "start",
                    value: "plant",
                },
                {
                    text: categoryName == "Maintainence Group" ?
                        this.$t("groupname") : this.$t("company"),
                    value: "value",
                },
                { text: this.$t("otherinfo"), value: "otherInfo" },
                { text: this.$t("updatedby"), value: "updatedBy" },
                { text: this.$t("updatedon"), value: "updatedOn" },
                { text: this.$t("actions"), value: "action", sortable: false },
            ];
        },
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ?
                this.selectedTab == 1 ?
                this.$t("newcompany") :
                this.selectedTab == 2 ?
                this.$t("newgroup") :
                this.selectedTab == 3 ?
                this.$t("newbusinessunit") :
                this.$t("newdiscipline") :
                this.selectedTab == 1 ?
                this.$t("editcompany") :
                this.selectedTab == 2 ?
                this.$t("editgroup") :
                this.selectedTab == 3 ?
                this.$t("editbusinessunit") :
                this.$t("editdiscipline");
        },
        computedDateFormatted() {
            return this.formatDate(this.date);
        },
        rowsperpage() {
            return this.$t("rowsperpage");
        },
        hasAdminAccess() {
            var adminaccess = false;
            var filterUser = [];
            filterUser = this.useraccess.filter(
                (x) => x.plant == "Global" || x.company == "LYB"
            );
            if (filterUser != null && filterUser.length > 0) {
                adminaccess = true;
            }
            return adminaccess;
        },
        isLoggedInUserActive() {
            var isuseractive = false;
            if (this.useraccess.length > 0) {
                this.useraccess.forEach(function (elem, index) {
                    if (elem.isActive == "Y") {
                        isuseractive = true;
                    }
                });
            }
            return isuseractive;
        },
        getTabName() {
            return this.selectedTab == 1 ?
                this.$t("company") :
                this.selectedTab == 2 ?
                this.$t("maintgrp") :
                this.selectedTab == 3 ?
                this.$t("businessunit") :
                this.$t("discipline");
        },
    },
    watch: {
        dialog(val) {
            val || this.close();
        },
        date(val) {
            this.dateFormatted = this.formatDate(this.date);
        },
    },
};
</script>



// WEBPACK FOOTER //
// ./src/components/PlantSpecificData.vue